import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommerceProduct, ProductSelection } from '../../models/commerce.models';

@Component({ selector: 'app-product-selection', templateUrl: './product-selection.component.html',
    styleUrls: ['./product-selection.component.scss'] })
export class ProductSelectionComponent {
    @Input() product: CommerceProduct;
    @Input() selection: ProductSelection;
    @Input() showDelivery = true;
    @Input() compact = false;
    @Output() changed = new EventEmitter<void>();
    trackById(index: number, entry: { id: number }): number { return entry.id; }
    sizeLabel(id: number, label: string): string {
        // Older size names include a price; ExtraCost is the current surcharge.
        const name = (label || '').replace(/(?:\s*\(\+\$\s*\d+(?:\.\d+)?\))+\s*$/, '').trim();
        const extraCost = this.product.sizes[id];
        return extraCost ? `${name} (+$${extraCost.toFixed(2)})` : name;
    }
    entries(values: { [id: string]: string }): Array<{ id: number; label: string }> {
        return Object.keys(values || {}).map(id => ({ id: +id, label: values[id] }));
    }
}
